import { Card, Table, Switch, Button, message, Space, Tag } from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import { useState, useEffect } from 'react'
import axios from 'axios'

function AutoSendSettings() {
  const [rows, setRows] = useState([]) // [{ typeGuid, typeName, autoSendEnabled, skipIfNoQr }]
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  const token = localStorage.getItem('token')
  const headers = { Authorization: `Bearer ${token}` }

  useEffect(() => {
    fetchSettings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchSettings = async () => {
    setLoading(true)
    try {
      const res = await axios.get('/api/settings/auto-send-settings', { headers })
      setRows(res.data)
    } catch (err) {
      message.error(err.response?.data?.error || 'خطأ في جلب الإعدادات')
    }
    setLoading(false)
  }

  const updateRow = (typeGuid, field, value) => {
    setRows(prev => prev.map(r => r.typeGuid === typeGuid ? { ...r, [field]: value } : r))
  }

  const handleSave = async () => {
    setSaving(true)
    try {
      await axios.put(
        '/api/settings/auto-send-settings',
        { settings: rows },
        { headers }
      )
      message.success('تم حفظ الإعدادات بنجاح ✅')
    } catch (err) {
      message.error(err.response?.data?.error || 'خطأ في الحفظ')
    }
    setSaving(false)
  }

  const enabledCount = rows.filter(r => r.autoSendEnabled).length

  const columns = [
    { title: 'نمط الفاتورة', dataIndex: 'typeName', key: 'typeName',
      render: name => <strong>{name}</strong> },
    {
      title: 'الإرسال التلقائي',
      key: 'autoSendEnabled',
      width: 160,
      render: (_, record) => (
        <Switch
          checked={record.autoSendEnabled}
          onChange={(checked) => updateRow(record.typeGuid, 'autoSendEnabled', checked)}
        />
      )
    },
    {
      title: 'تجاهل الفواتير بدون QR',
      key: 'skipIfNoQr',
      width: 200,
      render: (_, record) => (
        <Switch
          checked={record.skipIfNoQr}
          disabled={!record.autoSendEnabled}
          onChange={(checked) => updateRow(record.typeGuid, 'skipIfNoQr', checked)}
        />
      )
    },
  ]

  return (
    <Card
      title="إعدادات الإرسال التلقائي حسب النمط"
      loading={loading}
      extra={
        <Space>
          <Tag color={enabledCount > 0 ? 'green' : 'default'}>
            {enabledCount} نمط مفعَّل
          </Tag>
          <Button type="primary" icon={<SaveOutlined />} loading={saving} onClick={handleSave}>
            حفظ الإعدادات
          </Button>
        </Space>
      }
    >
      <p style={{ color: '#888', marginBottom: 16 }}>
        هذه الإعدادات مستقلة تماماً عن أي خيار بالـ ERP — كل نمط معطَّل افتراضياً حتى
        تفعّله صراحة من هنا. خيار "تجاهل الفواتير بدون QR" يمنع الإرسال التلقائي
        لأي فاتورة من هذا النمط لا تحمل رمز QR، بينما يبقى الإرسال اليدوي يعمل
        بشكل طبيعي بكل الأحوال.
      </p>

      <Table
        columns={columns}
        dataSource={rows}
        rowKey="typeGuid"
        pagination={false}
        size="small"
      />
    </Card>
  )
}

export default AutoSendSettings
